// extracted by mini-css-extract-plugin
module.exports = {"root":"IconChevron_root__FxnV9"};